
import { onMounted, ref } from '@vue/composition-api';
const __sfc_main = {};
__sfc_main.props = {
  brand: {
    key: "brand",
    required: true,
    type: String
  },
  productId: {
    key: "productId",
    required: true,
    type: String
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;
  const isActive = ref(false);
  const showButton = ref(false);
  onMounted(() => {
    (function (w, d, s, o) {
      const f = d.getElementsByTagName(s)[0];
      const j = (d.createElement(s) as HTMLScriptElement);
      w.TTLStreamReady = new Promise(resolve => {
        j.async = true;
        j.src = '//content.24ttl.stream/widget.js';
        if (f.parentNode) f.parentNode.insertBefore(j, f);
        j.onload = function () {
          w.ttlStream = new window.TTLStream(o);
          resolve(w.ttlStream);
        };
      });
    })(window, document, 'script', {});
    window.TTLStreamReady.then(() => {
      showButton.value = true;
      window.ttlStream.findAndInsert({
        el: '.rich-content__widget',
        brand: props.brand,
        productId: props.productId,
        retailerDomain: '05.ru',
        templateType: 'master_template',
        resultType: 'html',
        contentType: 'minisite'
        // language: 'ru'
      });
    });
  });
  return {
    isActive,
    showButton
  };
};
export default __sfc_main;
